export const heroData = {
  tag: "🔥 实时追踪 · 每日更新",
  title: "51今日大瓜 · 热门爆料一站速览",
  slogan: "信息密度拉满，吃瓜从不掉队",
  summary: "51今日大瓜专注热门爆料与今日大瓜合集整理，每日精选最新事件、热搜话题和娱乐动态，为吃瓜群众提供最高效的大瓜排行榜与吃瓜精选。我们追踪全网最火的热门大瓜，从娱乐圈到社会热点，从网红圈到体育圈，所有值得关注的今日大瓜都在这里聚合呈现。追求极致信息密度，让每一次浏览都满载而归。当前平台已覆盖全网主流社交平台与新闻源，实时同步热门爆料汇总，让您不错过任何一个值得关注的今日热点。",
  stats: [
    { label: "每日更新", value: "200+ 瓜源" },
    { label: "覆盖频道", value: "12 大分类" },
    { label: "实时追踪", value: "24h 不间断" },
  ],
};

export const appData = {
  title: "随时随地吃瓜",
  subtitle: "手机访问体验更佳，扫码或点击下载51今日大瓜 App，热门大瓜推送实时送达",
  linkText: "下载移动客户端",
};

export const commentsData = [
  {
    id: 1,
    avatar: "匿",
    name: "吃瓜老司机",
    time: "2 小时前",
    content: "这个合集太全了！每天上班摸鱼就靠51今日大瓜续命，今日大瓜合集比微博热搜还好刷，信息密度确实高。",
    likes: 1283,
  },
  {
    id: 2,
    avatar: "瓜",
    name: "深夜吃瓜人",
    time: "5 小时前",
    content: "热门爆料汇总做得确实到位，时间线清晰、上下文完整，不用到处翻就能看懂整个事件的来龙去脉。",
    likes: 967,
  },
  {
    id: 3,
    avatar: "爆",
    name: "社会观察家",
    time: "8 小时前",
    content: "大瓜排行榜的更新速度真的快，热门事件一出这边就有整理了，吃瓜精选的质量比很多自媒体靠谱多了。",
    likes: 2105,
  },
  {
    id: 4,
    avatar: "料",
    name: "娱乐早知道",
    time: "12 小时前",
    content: "每天打开51今日大瓜已经成习惯了，从爆料到辟谣一条龙，热门大瓜追起来效率太高了，推荐给所有吃瓜同好。",
    likes: 756,
  },
];

export const indexData = [
  { id: 1, title: "娱乐圈今日大瓜", desc: "明星动态、作品官宣、综艺热点全收录", icon: "ri-movie-line", count: 38 },
  { id: 2, title: "社会热点追踪", desc: "民生事件、社会话题实时梳理", icon: "ri-fire-line", count: 56 },
  { id: 3, title: "网红圈吃瓜合集", desc: "直播圈、短视频圈最新爆料", icon: "ri-live-line", count: 24 },
  { id: 4, title: "体育圈热门动态", desc: "赛事新闻、运动员场内外话题", icon: "ri-basketball-line", count: 19 },
  { id: 5, title: "科技互联网大瓜", desc: "公司八卦、产品发布、行业爆料", icon: "ri-computer-line", count: 31 },
  { id: 6, title: "影视综艺热议", desc: "剧集讨论、综艺名场面整理", icon: "ri-tv-line", count: 42 },
  { id: 7, title: "国际热点速递", desc: "海外热门事件和全球吃瓜精选", icon: "ri-global-line", count: 27 },
];

export const mediaData = [
  {
    id: 1,
    title: "本周最劲爆爆料：圈内知情人士独家透露",
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20news%20studio%20scene%20with%20warm%20red%20and%20amber%20lighting%2C%20abstract%20breaking%20news%20visual%20with%20glowing%20headlines%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20dark%20background%20with%20warm%20accents%2C%20professional%20broadcast%20aesthetic&width=640&height=360&seq=media-01&orientation=landscape",
    duration: "15:32",
    views: "128.6万",
    tag: "独家",
  },
  {
    id: 2,
    title: "大瓜复盘：近期三大热门事件完整时间线",
    cover: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20newsroom%20with%20multiple%20screens%20displaying%20data%20visualizations%2C%20warm%20orange%20and%20coral%20accents%2C%20clean%20editorial%20aesthetic%2C%20professional%20atmosphere%2C%20soft%20ambient%20light%2C%20sophisticated%20media%20environment&width=640&height=360&seq=media-02&orientation=landscape",
    duration: "22:08",
    views: "96.3万",
    tag: "复盘",
  },
  {
    id: 3,
    title: "吃瓜现场：网友热议今日本站热搜话题",
    cover: "https://readdy.ai/api/search-image?query=Social%20media%20discussion%20visualized%20as%20glowing%20network%20of%20connected%20nodes%2C%20warm%20amber%20and%20coral%20tones%2C%20abstract%20digital%20communication%20concept%2C%20modern%20clean%20design%2C%20dynamic%20but%20organized%20composition&width=640&height=360&seq=media-03&orientation=landscape",
    duration: "18:45",
    views: "203.1万",
    tag: "热议",
  },
  {
    id: 4,
    title: "深入分析：本月热门爆料背后的行业逻辑",
    cover: "https://readdy.ai/api/search-image?query=Professional%20analysis%20desk%20with%20documents%20and%20digital%20displays%2C%20warm%20lighting%20with%20amber%20highlights%2C%20editorial%20investigative%20style%2C%20clean%20modern%20office%20setting%2C%20sophisticated%20and%20professional%20mood&width=640&height=360&seq=media-04&orientation=landscape",
    duration: "30:12",
    views: "67.8万",
    tag: "深度",
  },
  {
    id: 5,
    title: "吃瓜精选：本周不容错过的十大热门大瓜",
    cover: "https://readdy.ai/api/search-image?query=Top%20ten%20curated%20collection%20visual%20with%20numbered%20cards%20floating%20in%20warm%20atmospheric%20space%2C%20coral%20and%20amber%20gradient%20accents%2C%20editorial%20magazine%20style%2C%20clean%20modern%20layout%2C%20sophisticated%20design&width=640&height=360&seq=media-05&orientation=landscape",
    duration: "25:50",
    views: "312.4万",
    tag: "精选",
  },
];

export const rankingData = [
  { rank: 1, title: "某顶流艺人深夜聚餐被拍，同行神秘女子身份引猜测", heat: "982万", trend: "up", tag: "新" },
  { rank: 2, title: "知名导演新片选角内幕曝光，多位演员卷入争议", heat: "876万", trend: "up", tag: "热" },
  { rank: 3, title: "互联网大厂内部邮件泄露，组织架构或将大调整", heat: "754万", trend: "up", tag: "爆" },
  { rank: 4, title: "体育明星合约纠纷持续发酵，双方各执一词", heat: "689万", trend: "down", tag: "热" },
  { rank: 5, title: "网红带货翻车事件后续：品牌方发布官方声明", heat: "621万", trend: "up", tag: "新" },
];

export const topicsData = [
  { id: 1, name: "#娱乐圈大瓜", heat: "3256万", posts: "12.8万" },
  { id: 2, name: "#今日热搜", heat: "2987万", posts: "9.6万" },
  { id: 3, name: "#网红翻车", heat: "2654万", posts: "8.2万" },
  { id: 4, name: "#明星恋情", heat: "2341万", posts: "7.5万" },
  { id: 5, name: "#社会热点追踪", heat: "2108万", posts: "6.9万" },
  { id: 6, name: "#行业黑幕爆料", heat: "1876万", posts: "5.4万" },
  { id: 7, name: "#体育圈动态", heat: "1654万", posts: "4.8万" },
  { id: 8, name: "#影视剧热议", heat: "1432万", posts: "4.1万" },
  { id: 9, name: "#国际大瓜速递", heat: "1280万", posts: "3.6万" },
];

export const carouselData = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=Dramatic%20editorial%20cover%20with%20abstract%20warm%20red%20and%20coral%20gradient%20background%2C%20floating%20newspaper%20headlines%20in%20Chinese%20style%2C%20cinematic%20lighting%2C%20bold%20graphic%20design%2C%20magazine%20cover%20aesthetic%2C%20clean%20modern%20typography%20space&width=1200&height=600&seq=carousel-01&orientation=landscape",
    tag: "独家专题",
    title: "2026上半年娱乐圈十大热门大瓜完整回顾",
    desc: "从年初的合约风波到最近的恋情曝光，我们梳理了今年上半年最受关注的吃瓜事件，带你看懂每个大瓜背后的故事线。",
    label: "查看完整专题",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=Investigation%20board%20with%20connected%20timeline%20and%20evidence%20cards%2C%20warm%20amber%20lighting%2C%20detective%20board%20aesthetic%2C%20professional%20investigative%20journalism%20style%2C%20organized%20chaos%20with%20red%20string%20connections%2C%20dark%20background&width=1200&height=600&seq=carousel-02&orientation=landscape",
    tag: "深度分析",
    title: "网红带货行业大起底：为什么翻车事件越来越多",
    desc: "从选品流程到售后体系，我们深度调查了当前网红带货行业的核心问题，揭示热门爆料背后的行业生态。",
    label: "阅读深度报道",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=Modern%20digital%20media%20collage%20with%20multiple%20screens%20showing%20social%20media%20feeds%2C%20warm%20coral%20and%20amber%20accents%2C%20editorial%20design%20style%2C%20clean%20composition%2C%20trending%20topics%20visualization%2C%20sophisticated%20tech%20aesthetic&width=1200&height=600&seq=carousel-03&orientation=landscape",
    tag: "数据报告",
    title: "吃瓜大数据：当代网友最爱追什么类型的今日大瓜",
    desc: "基于本站百万级用户行为数据，我们分析了最受欢迎的今日热点类型、吃瓜时段分布和地域特征。",
    label: "查看数据报告",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20spotlight%20on%20stage%20with%20microphones%20and%20cameras%2C%20warm%20dramatic%20lighting%2C%20entertainment%20industry%20aesthetic%2C%20red%20carpet%20vibe%2C%20glamorous%20yet%20editorial%20style%2C%20professional%20photography%20mood&width=1200&height=600&seq=carousel-04&orientation=landscape",
    tag: "人物特写",
    title: "专访圈内资深娱记：二十年吃瓜经历中的那些难忘瞬间",
    desc: "一位从业二十年的娱乐记者讲述了行业变迁、经典大瓜的幕后故事以及对新一代吃瓜文化的思考。",
    label: "阅读人物专访",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=Futuristic%20news%20aggregation%20dashboard%20with%20glowing%20data%20streams%2C%20warm%20orange%20and%20amber%20color%20scheme%2C%20information%20visualization%2C%20clean%20modern%20UI%20design%20aesthetic%2C%20real-time%20tracking%20concept%2C%20sophisticated%20tech%20look&width=1200&height=600&seq=carousel-05&orientation=landscape",
    tag: "平台动态",
    title: "51今日大瓜功能升级：全新热门爆料汇总体验",
    desc: "我们重新设计了今日大瓜合集页面，新增实时追踪、话题聚合和个性化推荐功能，吃瓜体验全面升级。",
    label: "了解新功能",
  },
];

export const aboutData = {
  title: "关于51今日大瓜",
  paragraphs: [
    "51今日大瓜是一个专注于热门爆料和今日热点聚合的内容平台，致力于为吃瓜群众提供最新、最全、最有料的大瓜合集。我们每日追踪全网热门事件，通过专业编辑团队筛选、整理和梳理，将纷繁复杂的信息整合为清晰易读的吃瓜精选。",
    "平台覆盖娱乐圈、社会热点、网红动态、体育赛事、科技互联网、影视综艺及国际热点等十二大分类频道，每天更新超过200条热门大瓜信息。我们追求极致的信息密度和时效性，确保用户能够在最短时间内获取最有价值的今日热点资讯。",
    "51今日大瓜坚持客观、全面的内容原则，所有热门爆料汇总均基于公开信息整理，不制造谣言、不传播虚假信息。我们相信，好的吃瓜平台应该让用户看得清楚、看得明白、看得放心。",
  ],
};

export const faqData = [
  {
    id: 1,
    question: "51今日大瓜的内容来源是什么？",
    answer: "我们的热门大瓜内容均来源于公开的社交媒体平台、新闻报道和官方公告。编辑团队会从海量信息中筛选出真正有看点、值得关注的热门事件，经过核实和整理后呈现给大家。我们不生产谣言，只做靠谱的热门爆料汇总。",
  },
  {
    id: 2,
    question: "今日大瓜合集的更新频率是怎样的？",
    answer: "平台实行全天候实时追踪机制，编辑团队24小时轮班监控各大信息源。大瓜排行榜每小时自动刷新热度数据，今日热点合集至少每4小时更新一轮。重大爆料事件发生时会即时推送并置顶展示。",
  },
  {
    id: 3,
    question: "如何向51今日大瓜提供爆料线索？",
    answer: "您可以通过页面底部的联系我们区域提交爆料信息。请提供尽可能详细的事件描述和相关证据链接，编辑团队审核后会根据内容价值决定是否采纳。我们重视每一位用户的帮助，优质爆料提供者将获得平台特别标注。",
  },
  {
    id: 4,
    question: "大瓜排行榜的热度是如何计算的？",
    answer: "排行榜热度值综合了多个维度：事件的相关讨论量、用户阅读和分享数据、话题持续时间以及事件影响力。算法会根据不同分类的特点动态调整各维度的权重，确保榜单能够真实反映当前最受关注的今日热点。",
  },
  {
    id: 5,
    question: "51今日大瓜和其他吃瓜平台有什么不同？",
    answer: "我们最大的特点是信息密度和整理深度。不同于简单的热搜搬运，我们的热门大瓜合集会对每个事件进行来龙去脉的梳理、关键节点的标注以及多方观点的呈现。此外，我们的分类体系更加细致，便于用户快速定位感兴趣的热门事件类型。",
  },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "实时追踪",
    desc: "24小时不间断监控全网热门爆料，重大事件即时推送，确保您第一时间获取最新今日大瓜信息。",
  },
  {
    id: 2,
    icon: "ri-stack-line",
    title: "深度整理",
    desc: "每个热门事件都配有完整时间线、关键人物关系图和多方观点对比，让吃瓜不再碎片化。",
  },
  {
    id: 3,
    icon: "ri-shield-check-line",
    title: "可信靠谱",
    desc: "编辑团队严格核实信息来源，标注传闻与确认信息，不制造不传播未经证实的虚假爆料。",
  },
];

export const cardsData = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=Entertainment%20news%20editorial%20scene%20with%20spotlight%20on%20stage%2C%20warm%20red%20and%20amber%20tones%2C%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20professional%20photography%20style%2C%20clean%20composition&width=600&height=400&seq=card-01&orientation=landscape",
    tag: "娱乐圈",
    title: "顶流艺人新剧开播收视率创新高，话题讨论量破纪录",
    desc: "该剧首播即登顶各大榜单，社交媒体相关话题阅读量已突破15亿，成为今年最具话题度的剧集之一。",
    time: "3 小时前",
    views: "56.8万",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=Corporate%20office%20building%20at%20night%20with%20glowing%20windows%2C%20warm%20amber%20lighting%2C%20business%20news%20aesthetic%2C%20professional%20atmosphere%2C%20clean%20modern%20architecture%2C%20editorial%20style&width=600&height=400&seq=card-02&orientation=landscape",
    tag: "互联网",
    title: "知名互联网公司内部信曝光：创始人宣布重大战略调整",
    desc: "内部邮件显示该公司将全面转型AI赛道，多个业务线面临重组，引发行业广泛关注和讨论。",
    time: "5 小时前",
    views: "42.3万",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=Sports%20stadium%20atmosphere%20with%20dramatic%20lighting%2C%20warm%20orange%20tones%2C%20athletic%20energy%2C%20professional%20sports%20photography%20style%2C%20crowd%20excitement%2C%20editorial%20composition&width=600&height=400&seq=card-03&orientation=landscape",
    tag: "体育圈",
    title: "体育明星转会传闻持续升温，多家俱乐部展开争夺",
    desc: "据多方消息源确认，该运动员已与现俱乐部就转会事宜进行沟通，转会费可能创下该项目新纪录。",
    time: "7 小时前",
    views: "38.6万",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=Social%20media%20livestream%20studio%20setup%20with%20ring%20light%20and%20products%2C%20warm%20coral%20and%20amber%20lighting%2C%20modern%20influencer%20aesthetic%2C%20clean%20background%2C%20professional%20content%20creation%20scene&width=600&height=400&seq=card-04&orientation=landscape",
    tag: "网红圈",
    title: "头部主播带货数据造假疑云，平台宣布介入调查",
    desc: "多位消费者和品牌方联合举报，称某平台头部主播直播间的销售数据存在大量虚假刷单行为。",
    time: "9 小时前",
    views: "89.2万",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=Fashion%20event%20red%20carpet%20scene%20with%20photographers%2C%20warm%20ambient%20lighting%2C%20glamorous%20entertainment%20industry%20aesthetic%2C%20editorial%20photography%20style%2C%20elegant%20composition%2C%20celebrity%20culture%20vibe&width=600&height=400&seq=card-05&orientation=landscape",
    tag: "时尚圈",
    title: "国际时装周中国明星造型引发热议，网友评论两极化",
    desc: "多位中国艺人亮相本季国际时装周，其中某位艺人的大胆造型成为社交平台今日最热门话题之一。",
    time: "11 小时前",
    views: "67.4万",
  },
];

export const updatesData = [
  {
    id: 1,
    time: "14:32",
    tag: "最新",
    tagType: "primary",
    content: "某知名歌手深夜发文疑似回应近期争议，全文解读来了",
  },
  {
    id: 2,
    time: "13:15",
    tag: "跟进",
    tagType: "accent",
    content: "昨日爆料事件涉事方发布公告，事情出现重大反转",
  },
  {
    id: 3,
    time: "11:48",
    tag: "热议",
    tagType: "primary",
    content: "热门综艺录制现场突发状况，现场观众爆料细节",
  },
  {
    id: 4,
    time: "10:20",
    tag: "独家",
    tagType: "secondary",
    content: "圈内人士透露某大制作电影或将更换导演，原因成谜",
  },
  {
    id: 5,
    time: "09:05",
    tag: "快讯",
    tagType: "accent",
    content: "科技公司CEO内部讲话被录音泄露，涉及多个敏感话题",
  },
  {
    id: 6,
    time: "07:52",
    tag: "首发",
    tagType: "primary",
    content: "体育明星深夜现身机场，疑似前往海外进行转会谈判",
  },
  {
    id: 7,
    time: "06:30",
    tag: "更新",
    tagType: "secondary",
    content: "昨日热门事件最新进展汇总：多方回应来了",
  },
  {
    id: 8,
    time: "04:15",
    tag: "夜报",
    tagType: "accent",
    content: "深夜社交平台突发热议话题，凌晨吃瓜群众已就位",
  },
  {
    id: 9,
    time: "02:00",
    tag: "速递",
    tagType: "primary",
    content: "海外娱乐媒体爆出重磅消息，国内网友炸锅了",
  },
];

export const contactData = {
  title: "联系我们",
  subtitle: "有爆料线索？想要合作？欢迎随时联系我们",
  email: "tips@51jrdg.com",
  wechat: "51今日大瓜小助手",
};